import services from '~api/statistics';
import * as types from '../types';

export default {

  getSignInList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetSignInList(payload).then((res) => {
        if (res.data) {
          commit(types.GET_SIGN_IN_LIST, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getSignInDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetSignInDetail(payload).then((res) => {
        if (res.data) {
          commit(types.GET_SIGN_IN_DETAIL, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  handleSignInExport({ commit }, payload) {
    return services.apiHandleSignInExport(payload.params, payload.config);
  },
  getSalesmanTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetSalesmanTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_SALESMAN_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getBusiLineTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetBusiLineTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_BUSI_LINE_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCustomTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomClassifyTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUSTOM_CLASSIFY_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getDepaBusiLineTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetDepaBusiLineTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_DEPA_BUSILINE_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getThreeBusiLineTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetThreeBusiLineTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_THREE_BUSILINE_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getDepartmentTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetDepartmentTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_DEPARTMENT_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCusInsuranceTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUS_INSURANCE_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCusBankTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUS_BANK_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCusHealthManagementTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUS_HEALTH_MANAGEMENT_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCusInternetTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUS_INTERNET_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCusOprationTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUS_OPRATION_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getDep3OfBusPerformanceTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetDep3OfBusPerformanceTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_DEP30F_BUS_PERFORMANCE_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCustomerRevenueTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomerRevenueTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUSTOMER_REVENUE_TABLE_DATA, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取打卡记录列表
  getTimingRecordList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetTimingRecordList(payload).then((res) => {
        if (res.data) {
          commit(types.GET_TIMING_RECORD_LIST, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取打卡记录团队
  getTimingRecordTeams({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetTimingRecordTeams(payload).then((res) => {
        if (res.data) {
          commit(types.GET_TIMING_RECORD_TEAMS, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取打卡记录详情
  getTimingDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetTimingRecordDetail(payload).then((res) => {
        if (res.data) {
          commit(types.GET_TIMING_RECORD_DETAIL, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取项目线上服务列表
  getProOnlineTopTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetProOnlineTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_PRO_ONLINE_TOP, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取项目线下服务列表
  getProOfflineTopTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetProOfflineTopTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_PRO_OFFLINE_TOP, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取电话咨询列表
  getTelCounselingTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetTelCounselingTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_TEL_COUNSELING, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  // 获取线下服务列表
  getOfflineServiceTableData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetOfflineServiceTableData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_OFFLINE_SERVICE, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  customSelectSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetCustomSelectData(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CUSTOM_SELECT, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getDoctelConnectionList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apiGetDoctelConnectionList(payload).then((res) => {
        if (res.data) {
          commit(types.GET_DOCTEL_CONNECTION, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getStatiisticsTeamList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services.apigetStatiisticsTeamList(payload).then((res) => {
        if (res.data) {
          const func = data => data.forEach((item) => {
            if (item.children.length === 0) {
              delete item.children;
            } else {
              func(item.children);
            }
          });
          func(res.data.children);
          const arr = [{
            ...res.data,
            children: res.data.children,
          }];


          commit(types.GET_STATISTICS_TEAM_LIST, arr);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },
};
